/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MagellanLogoColored } from 'library';
import lightBulbImage from 'assets/img/error_light_bulb.png';

const ErrorScreen = ({ isAdmin }) => {
  const navigate = useNavigate();

  const onButtonClick = action => {
    if (action === 'back') {
      // eslint-disable-next-line no-restricted-globals
      history.back();
    } else if (action === 'home') {
      window.location.replace('/');
    } else {
      navigate('../security');
    }
  };

  const supportContact = 'commercialtechnology@magellanlp.com';

  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.light',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        height: { xs: 'calc(100vh - 56px)', md: 'calc(100vh - 48px)' },
        justifyContent: 'center',
        position: 'relative',
        width: '100vw',
        mt: 4,
      }}
    >
      <img
        alt="Shattered light bulb error message"
        src={lightBulbImage}
        style={{
          position: 'absolute',
          right: '25%',
          top: '5%',
          width: 800,
        }}
      />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: { xs: 24, md: 'unset' },
          padding: { xs: 3, md: 'unset' },
          textAlign: { xs: 'center', md: 'unset' },
          zIndex: 1,
        }}
      >
        <Typography sx={{ mb: 4 }} variant={mdUp ? 'h3' : 'h4'}>
          Sorry, a carrier affiliate is required.
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            hyphens: 'none',
          }}
          variant="h6"
        >
          Please feel free to add a carrier affiiliate to your profile and try again.
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            hyphens: 'none',
          }}
          variant="h6"
        >
          If you continue to experience this issue please call our support team at{' '}
          <Typography component="span" noWrap>
            {supportContact}
          </Typography>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            marginTop: { xs: 2, md: 'unset' },
          }}
        >
          {isAdmin ? (
            <Button
              onClick={() => onButtonClick('security')}
              sx={{
                mx: { xs: 0, md: 2 },
                my: { xs: 1, md: 4 },
                minWidth: 150,
              }}
              variant="outlined"
            >
              User Permissions
            </Button>
          ) : (
            <Button
              onClick={() => onButtonClick('back')}
              sx={{
                mx: { xs: 0, md: 2 },
                my: { xs: 1, md: 4 },
                minWidth: 150,
              }}
              variant="outlined"
            >
              Go Back A Page
            </Button>
          )}
          <Button
            onClick={() => onButtonClick('home')}
            sx={{
              mx: { xs: 0, md: 2 },
              my: { xs: 1, md: 4 },
              minWidth: 150,
            }}
            variant="outlined"
          >
            Return Home
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          bottom: { md: 64 },
          display: { xs: 'none', md: 'unset' },
          left: { md: 'calc(50% - 113px)' },
          position: { md: 'absolute' },
          width: { md: 226 },
        }}
      >
        <MagellanLogoColored sx={{ width: '100%' }} />
      </Box>
    </Box>
  );
};

ErrorScreen.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

export default ErrorScreen;
